<template>
    <div class="input-table">
        <div
          v-if="items.length"
          class="input-table-shadow"
        >
            <div class="d-flex row align-items-center">
                <div class="col-2 border-right">
                    <input class="pl-3" type="text" readonly="readonly" :value="frontEndDateFormat(fromDate)" />
                </div>
                <core-drop-down
                    class="col-3 border-right"
                    v-if="origin.length"
                    :items="origin"
                    v-model="selectedOriginStation"
                    :selectedValue.sync="selectedOriginStation"
                    noLabel
                ></core-drop-down>
                <div class="col border-right">
                    <input type="text" readonly="readonly" :value="getOriginTime()" />
                </div>
                <core-drop-down
                    class="col-3 border-right"
                    v-if="destination.length"
                    :items="destination"
                    v-model="selectedDestinationStation"
                    :selectedValue.sync="selectedDestinationStation"
                    noLabel
                ></core-drop-down>
                <div class="col border-right">
                  <input type="text" readonly="readonly" :value="getDestinationTime()" />
                </div>
                <div class="col">
                  <input type="text" readonly="readonly" :value="getNights" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    times: {
      type: Array,
      required: true
    },
    originStation: {
      default: null,
      type: Object,
      required: false
    },
    destinationStation: {
      default: null,
      type: Object,
      required: false
    },
    departureDate: {
      default: null,
      type: String,
      required: false
    },
    arrivalDate: {
      default: null,
      type: String,
      required: false
    }
  },
  data () {
    return {
      items: this.times,
      selectedOriginStation: this.originStation,
      selectedDestinationStation: this.destinationStation,
      origin: [],
      destination: [],
      fromDate: this.departureDate,
      untilDate: this.arrivalDate
    }
  },
  created () {
    if (this.items.length) {
      this.createOriginAndDestination()
    }
  },
  computed: {
    getNights () {
      let from = this.$moment(this.fromDate, 'YYYY-MM-DD')
      let until = this.$moment(this.untilDate, 'YYYY-MM-DD')
      return from.diff(until, 'days') + 1
    }
  },
  methods: {
    createOriginAndDestination () {
      this.items.forEach((item) => {
        if (item.origin) {
          this.origin.push(item.station)
        } else {
          this.destination.push(item.station)
        }
      })
      if (!this.selectedOriginStation && this.origin.length) {
        this.selectedOriginStation = this.origin[0]
      }
      if (!this.selectedDestinationStation && this.destination.length) {
        this.selectedDestinationStation = this.destination[0]
      }
    },
    getOriginTime () {
      if (this.selectedOriginStation) {
        let originTime = null
        this.items.forEach((item) => {
          // Transport time
          if (item.hasOwnProperty('station')) {
            if (item.station.id === this.selectedOriginStation.id) {
              originTime = item
            }
          } else {
            if (item.stationOrigin.id === this.selectedOriginStation.id) {
              originTime = item
            }
          }
        })
        if (originTime) {
          return this.$moment(originTime.time, 'HH:mm:ss').format('HH:mm')
        }
      }
    },
    getDestinationTime () {
      if (this.selectedDestinationStation) {
        let destinationTime = null
        this.items.forEach((item) => {
          // Transport time
          if (item.hasOwnProperty('station')) {
            if (item.station.id === this.selectedDestinationStation.id) {
              destinationTime = item
            }
          } else {
            if (item.stationDestination.id === this.selectedDestinationStation.id) {
              destinationTime = item
            }
          }
        })
        if (destinationTime) {
          return this.$moment(destinationTime.time, 'HH:mm:ss').format('HH:mm')
        }
      }
    },
    frontEndDateFormat (date) {
      if (!date) {
        return ''
      }
      return this.$moment(date, 'YYYY-MM-DD').format('DD/MM')
    }
  },
  watch: {
    selectedOriginStation (val) {
      this.$emit('update:originStation', val)
    },
    selectedDestinationStation (val) {
      this.$emit('update:destinationStation', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservation/details/TransportTime.vue